import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { STAGES } from './salesData';

/**
 * "Todo lo que recibís": los 100 scripts organizados en las 6 etapas de una
 * conversación de venta, cada etapa con un ejemplo real del mensaje.
 */
export function ScriptsSection() {
  return <section id="scripts" className="w-full bg-ink py-16 text-white sm:py-20" data-id="element-167" data-mp="1876pn2p3tksu">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-6" data-id="element-168" data-mp="ucmfzc6x69ny">
        <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:items-start lg:gap-12" data-id="element-169" data-mp="z4xeqbpxbpex">
          <div className="lg:sticky lg:top-10" data-id="element-170" data-mp="kg9l4azn1prm">
            <SectionTag tone="dark" data-id="element-171" data-mp="khkoi9p68vi7">Todo lo que recibís</SectionTag>
            <p className="mt-5 font-display text-[5rem] font-extrabold leading-[0.85] text-wa sm:text-[6.5rem]" data-id="element-172" data-mp="pfw0apz11g32">
              100
            </p>
            <h2 className="mt-2 font-display text-[1.85rem] font-extrabold leading-tight sm:text-[2.3rem]" data-id="element-173" data-mp="bhfkm9j6sf8s">
              scripts organizados en 6 etapas
            </h2>
            <p className="mt-3 max-w-md font-sans text-[1rem] leading-relaxed text-white/65" data-id="element-174" data-mp="3mzh5dcur49cc">
              No es una lista suelta de frases. Es la conversación entera cubierta, desde
              el «hola, ¿cuánto sale?» hasta el «dale, pasame los datos».
            </p>
            <CTAButton className="mt-7 w-full sm:w-auto" data-id="element-175" data-mp="3s16hkvtpmt20" />
          </div>

          <ul className="flex flex-col gap-3" data-id="element-176" data-mp="34aarq48te7xe">
            {STAGES.map((stage, index) => <motion.li key={stage.num} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.3,
            delay: Math.min(index * 0.04, 0.2),
            ease: [0.23, 1, 0.32, 1]
          }} className="rounded-2xl border border-graphite-line bg-graphite p-5 sm:p-6" data-id="element-177" data-mp="2zbr664y4uy5k" data-mpi={index}>
                <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-178" data-mp="ki3c0xwkf0jw">
                  <span className="font-display text-[0.72rem] font-bold tracking-[0.12em] text-white/35" data-id="element-179" data-mp="kg0nkib29fha">
                    {stage.num}
                  </span>
                  <h3 className="font-display text-[1.1rem] font-bold leading-snug text-white sm:text-[1.2rem]" data-id="element-180" data-mp="u86fxt585yx0">
                    {stage.name}
                  </h3>
                  <span className="rounded-full bg-wa px-2.5 py-0.5 font-display text-[0.65rem] font-bold uppercase tracking-[0.06em] text-ink" data-id="element-181" data-mp="1jr2vc5nlqob">
                    {stage.count}
                  </span>
                </div>
                <p className="mt-2 font-sans text-[0.92rem] leading-relaxed text-white/60" data-id="element-182" data-mp="aiw2ymwv5s2l">
                  {stage.desc}
                </p>
                <p className="mt-3.5 rounded-2xl rounded-bl-md bg-white/[0.07] px-4 py-3 font-sans text-[0.88rem] leading-snug text-white/85" data-id="element-183" data-mp="1lyufj0r92w8k">
                  {stage.sample}
                </p>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}